
import { Vue, Component } from "vue-property-decorator";
import { uiStore } from "@/store/store";

@Component({})
export default class OxyPanelMask extends Vue {
  get showMask() {
    return uiStore.panelState.oxyPanelIsMasked;
  }

  closeMask() {
    uiStore.setPanelState({
      ...uiStore.panelState,
      oxyPanelIsMasked: false
    });
  }
}
